import { useEffect } from 'react';

/**
 * Hook rejestrujący globalne handlery mousemove/mouseup/touchmove/touchend.
 * Zbiera tablice handlerów ze wszystkich hooków i rejestruje je jako listenery na window.
 */
export function useGlobalMouseHandlers({ moveHandlers, upHandlers, deps }) {
  useEffect(() => {
    const handleMouseMove = (e) => {
      moveHandlers.forEach(handler => handler(e));
    };

    const handleMouseUp = () => {
      upHandlers.forEach(handler => handler());
    };

    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);
    window.addEventListener('touchmove', handleMouseMove);
    window.addEventListener('touchend', handleMouseUp);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
      window.removeEventListener('touchmove', handleMouseMove);
      window.removeEventListener('touchend', handleMouseUp);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
